import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import axios from 'axios';
import { cn } from '@/lib/utils';
import { FormattedMessage } from 'react-intl';

const GEOCODE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
const API_KEY = import.meta.env.VITE_APP_GOOGLE_GEOCODE_API_KEY;

const ContactLocationMap = ({
  contacts,
  height = '600px',
  isCollapsed,
  selectedContact,
  setSelectedContact,
  setSelectionSource
}) => {
  const [locations, setLocations] = useState([]);
  const { isLoaded } = useJsApiLoader({ googleMapsApiKey: API_KEY });

  const containerStyle = {
    width: '100%',
    height,
    borderRadius: '10px',
    transition: 'all 0.5s ease-in-out',
  };

  const defaultCenter = { lat: 39.8283, lng: -98.5795 };

  function decodeHTMLEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  useEffect(() => {
    if (selectedContact?.id && !selectedContact?.lat) {
      const match = locations.find(loc => loc.id === selectedContact.id);
      if (match) {
        setSelectedContact(match); // replaces it with version that includes lat/lng
      }
    }
  }, [selectedContact, locations]);

  useEffect(() => {
    if (!contacts || contacts.length === 0) {
      setLocations([]);
      return;
    }

    const fetchCoordinates = async () => {
      const coords = [];

      for (const contact of contacts) {
        const addr = contact.address?.[0];
        if (!addr) continue;
        // ${addr.address},
        const fullAddress = [addr?.city, addr?.state, addr?.zip].filter(Boolean).join(', ');

        try {
          const res = await axios.get(GEOCODE_URL, {
            params: {
              address: fullAddress,
              key: API_KEY
            }
          });

          const data = res.data;

          if (data.status === 'OK') {
            const location = data.results[0].geometry.location;
            coords.push({
              id: contact.id,
              // name: `${contact.first_name} ${contact.last_name}`,
              address: fullAddress,
              lat: location.lat,
              lng: location.lng,
              speciality: decodeHTMLEntities(contact.speciality)
            });
          }
        } catch (err) {
          console.error('Geocode error:', fullAddress, err);
        }
      }

      setLocations(coords);
    };

    fetchCoordinates();
  }, [contacts]);

  if (!isLoaded) return <div className='text-center text-sm'><FormattedMessage id="add_referral.loading_google_maps" /></div>;

  return (
    <div className="relative">
      <div
        className={cn(
          'slide-transition overflow-hidden',
          'card mb-2',
          isCollapsed
            ? 'opacity-100 translate-y-0 max-h-[600px]'
            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
        )}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={
            selectedContact?.lat && selectedContact?.lng
              ? { lat: selectedContact.lat, lng: selectedContact.lng }
              : locations.length > 0
                ? { lat: locations[0].lat, lng: locations[0].lng }
                : defaultCenter
          }
          zoom={selectedContact ? 10 : 4}
        >
          {locations.map((loc) => (
            <Marker
              key={loc.id}
              position={{ lat: loc.lat, lng: loc.lng }}
              onClick={() => {
                setSelectionSource('map')
                setSelectedContact(loc)
              }}
            />
          ))}

          {selectedContact && selectedContact.lat && selectedContact.lng && (
            <InfoWindow
              position={{ lat: selectedContact.lat, lng: selectedContact.lng }}
              onCloseClick={() => setSelectedContact(null)}
            >
              <div>
                <h4 className='contact-map-pin-name'>{selectedContact.name}</h4>
                <span className='contact-map-pin-address'>
                  {console.log('selectedContact', selectedContact)}
                  {selectedContact.address} <br />
                  Specialty:  {selectedContact.speciality}
                </span>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </div>

      {!isCollapsed && (
        <div className="text-center text-sm transition-opacity duration-500 opacity-100">
          <FormattedMessage id="MAP.COLLAPSED" />
        </div>
      )}
    </div>
  );
};

export { ContactLocationMap };